var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"globalSettins_page"},[_c('div',{staticClass:"settings_list"},_vm._l((_vm.settings),function(setting,key){return _c('GlobalSettingsItem',{key:key,staticClass:"setting-item",attrs:{"setting":setting,"name":key},on:{"update":_vm.init}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }